import { useEffect, useState } from "react";
import { getScoreHistory } from "../../../network/service/NutritionService";
import { gradeName } from "./grade-names";

const REASONS = { EDIT: "Edited", AUTO_FILL: "Auto-filled", RESCORE: "New algorithm" };

const formatDate = (iso) =>
  new Date(iso).toLocaleString(undefined, { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

/** Every recorded score of a product, newest first, with why it changed. */
function ScoreHistoryPanel({ productId }) {
  const [entries, setEntries] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    getScoreHistory(productId)
      .then((d) => !cancelled && setEntries(d))
      .catch((e) => !cancelled && setError(e.message));
    return () => {
      cancelled = true;
    };
  }, [productId]);

  if (error) return <p className="text-danger">{error}</p>;
  if (!entries) return <p className="nutri-muted">Loading history…</p>;
  if (!entries.length) return <p className="nutri-muted">No scores recorded yet.</p>;

  return (
    <div className="nutri-card">
      <ol className="list-unstyled mb-0">
        {entries.map((e) => (
          <li key={e.id} className="mb-3">
            <div>
              <strong>{e.score}</strong> · {gradeName(e.grade)} · <span className="nutri-muted">{e.scoreVersion}</span>
              {e.confidence && <span className="nutri-muted"> · {e.confidence.toLowerCase()} confidence</span>}
            </div>
            <small className="nutri-muted">
              {formatDate(e.createdAt)}
              {e.reason && ` · ${REASONS[e.reason] ?? e.reason}`}
              {e.dataCompleteness != null && ` · ${e.dataCompleteness}% complete`}
            </small>
            {e.change && e.change.delta !== 0 && (
              <div className="small">
                {e.change.summary}
                {!e.change.explained && (
                  <span className="nutri-muted"> (older entry without details)</span>
                )}
              </div>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}

export default ScoreHistoryPanel;
